
<app-section-layout [dataForChart]="graphData" [itemTemplate]="FCFGraph"></app-section-layout>

<ng-template #FCFGraph let-data="data" let-navInfo="navInfo">
    <app-fcf-slide [data]="data" [navInfo]="navInfo"></app-fcf-slide>
</ng-template>
